var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityFinanceFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dish",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815",
    "data-name": "Ellipse 2815",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#63c5b7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55461",
    "data-name": "Path 55461",
    d: "M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z",
    transform: "translate(7 7)",
    fill: "#dff9ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48186",
    "data-name": "Group 48186",
    transform: "translate(11.297 9.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55432",
    "data-name": "Path 55432",
    d: "M251.865,135.965a2.439,2.439,0,0,1-1.82-.8,2.236,2.236,0,0,1-.565-1.738l.508-11.35a3.653,3.653,0,0,1-1.881-2.545,8.38,8.38,0,0,1,.234-3.883l.453-1.492a3.241,3.241,0,0,1,6.137,0l.453,1.492a8.38,8.38,0,0,1,.234,3.883,3.652,3.652,0,0,1-1.88,2.545l.51,11.4a2.206,2.206,0,0,1-.565,1.691,2.439,2.439,0,0,1-1.818.8Zm0-22.594a1.772,1.772,0,0,0-1.717,1.2l-.453,1.493a6.963,6.963,0,0,0-.194,3.224,2.239,2.239,0,0,0,1.465,1.687.706.706,0,0,1,.457.693l-.532,11.872a.848.848,0,0,0,.208.686,1.091,1.091,0,0,0,1.535,0,.817.817,0,0,0,.212-.64l-.537-11.919a.706.706,0,0,1,.457-.693,2.239,2.239,0,0,0,1.465-1.687,6.971,6.971,0,0,0-.193-3.224l-.453-1.493a1.772,1.772,0,0,0-1.718-1.2Z",
    transform: "translate(-237.391 -111.955)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55433",
    "data-name": "Path 55433",
    d: "M131.883,136.006a2.386,2.386,0,0,1-2.385-2.388q0-.058,0-.117l.6-12.045-1.9-1.9a.706.706,0,0,1-.207-.5v-6.355a.706.706,0,1,1,1.412,0v6.062l1.911,1.911a.706.706,0,0,1,.207.534l-.618,12.356a.962.962,0,0,0,.267.719.994.994,0,0,0,1.406.006l.006-.006a.962.962,0,0,0,.267-.719l-.622-12.356a.706.706,0,0,1,.206-.534l1.912-1.911v-6.062a.706.706,0,1,1,1.412,0v6.355a.706.706,0,0,1-.207.5l-1.9,1.9.6,12.045A2.386,2.386,0,0,1,132,136Z",
    transform: "translate(-128 -111.996)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55434",
    "data-name": "Path 55434",
    d: "M152.706,119.061a.706.706,0,0,1-.706-.706v-5.649a.706.706,0,1,1,1.412,0v5.649A.706.706,0,0,1,152.706,119.061Z",
    transform: "translate(-149.882 -111.996)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55435",
    "data-name": "Path 55435",
    d: "M176.706,119.061a.706.706,0,0,1-.706-.706v-5.649a.706.706,0,1,1,1.412,0v5.649A.706.706,0,0,1,176.706,119.061Z",
    transform: "translate(-171.764 -111.996)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityFinanceFood);
export default __webpack_public_path__ + "static/media/university-finance-food.756540763ca89a6d478d20ecadbeec19.svg";
export { ForwardRef as ReactComponent };